import { render, staticRenderFns } from "./TweetsMetricsCardFooter.vue?vue&type=template&id=38a1ccc5&"
import script from "./TweetsMetricsCardFooter.vue?vue&type=script&lang=js&"
export * from "./TweetsMetricsCardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports